import packageJson from "../package.json";

/**
 * Optional CI/build pipeline vars (set at `npm run build` time):
 * REACT_APP_BUILD_TIME — ISO timestamp or build id
 * REACT_APP_GIT_SHA — short commit hash
 */
export function logAwsIicBuildInfo(): void {
  const buildTime = process.env.REACT_APP_BUILD_TIME;
  const gitSha = process.env.REACT_APP_GIT_SHA;

  console.info("[aws-iic-app] deploy fingerprint", {
    app: packageJson.name,
    version: packageJson.version,
    env: process.env.NODE_ENV,
    buildTime: buildTime || "(not set — add REACT_APP_BUILD_TIME in CI for clearer deploy ids)",
    gitSha: gitSha || "(not set — add REACT_APP_GIT_SHA in CI for commit verification)",
  });
}
